import React from 'react';
import PropTypes from 'prop-types';

export const StatusCircle = ({ size, color }) => (
  <div
    style={{
      width: size,
      height: size,
      borderRadius: size / 2,
      backgroundColor: color,
    }}
  />
);
StatusCircle.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
};
